import { useRouter } from 'next/router'
// Sanity
import { getClient } from '../client'
import {
  propsSanity,
  groqSanityPageQuery,
  sanitySrcUrl,
} from '../lib/libFunctions'

import { useRef } from 'react'
import Head from 'next/head'
// Styles
import { base } from '../styles/base/_allBase.styles'
const {
  GridItem_HeaderSection,
  GridContainer_Page_Layout,
  Page_Main_Grid_Container,
} = base
// Components
import SEO from '../components/seo-head/seo-head'
import { Header } from '../components/header/header'
import SectionOne from '../components/section-one/section-one'
import { ContactInfoSection } from '../components/contact-information-section/contact-information-section'
import { ContactInputSection } from '../components/contact-input-section/contact-input-section'
import { Footer } from '../components/footer/footer.component'
// Assets
import Surfer from '../assets/images/surfer.jpg'

export default function Home(props) {
  const sectionOneRef = useRef()
  const router = useRouter()

  const { header, PageContactSection } = props.data.data
  const { seo } = props.data

  console.log(props)

  return (
    <GridContainer_Page_Layout>
      <SEO seo={seo} router={router} header={header} />
      <GridItem_HeaderSection>
        <header ref={sectionOneRef}>
          <Header />
        </header>
      </GridItem_HeaderSection>
      <main>
        <Page_Main_Grid_Container>
          <SectionOne header={header} />
          <ContactInfoSection data={PageContactSection.content[0]} />
          <ContactInputSection
            image={sanitySrcUrl(PageContactSection.content[0].mainImage)}
          />
          <Footer
            toTopRef={sectionOneRef}
            data={PageContactSection.content[0]}
          />
        </Page_Main_Grid_Container>
      </main>
    </GridContainer_Page_Layout>
  )
}

export async function getServerSideProps() {
  const query = groqSanityPageQuery('contact')
  const data = await getClient().fetch(query, {})

  return {
    props: {
      data: propsSanity(data),
    },
  }
}
